<template>
  <div class="pa-3 grey lighten-4">
    <v-layout row wrap>
      <v-flex v-if="userRoleInCompany >= DEFINES.ROLE_MEMBER" xs12>
        <v-card>
          <v-card-title class="grey lighten-4">
            <v-icon large left color="grey"
              >$vuetify.icons.rms_activities</v-icon
            >
            <div>
              <div class="title font-weight-light">
                {{ $t("company.dashboard.activity.recent_activities.title") }}
              </div>
              <div class="body-1 grey--text text--darken-1">
                {{ $t("screener.company.dashboard.activities.subtitle") }}
              </div>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="activity_headers"
            :loading="loading"
            :items="recent_activities"
            :pagination.sync="pagination"
            :total-items="total"
            :rowsPerPageItems="rowsPerPageItems"
            class="elevation-1"
            item-key="id"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.description }}</td>
                <td class="text-xs-left">{{ props.item.log_name }}</td>
                <td v-if="props.item.causer" class="text-xs-left">
                  {{ props.item.causer.name }}
                </td>
                <td v-else>---</td>
                <td class="text-xs-left">
                  {{ moment.utc(props.item.created_at).local().fromNow() }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import DEFINES from "@/defines";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import moment from "moment";
import i18n from "@/i18n";
export default {
  name: "CompanyHistory",
  data() {
    return {
      activity_headers: [
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.sn"),
          align: "left",
          sortable: false,
        },
        {
          text: i18n.t(
            "company.dashboard.recent_activity.table.header.activity"
          ),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.type"),
          sortable: false,
        },
        {
          text: i18n.t(
            "company.dashboard.recent_activity.table.header.performed_by"
          ),
          sortable: false,
        },
        {
          text: i18n.t("company.dashboard.recent_activity.table.header.date"),
          sortable: false,
        },
      ],
      rowsPerPageItems: [10],
      pagination: {
        sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      loading: false,
      total: null
    };
  },
  watch: {
    pagination: {
      handler: "getRecentActivities",
      deep: true
    }
  },
  computed: {
      ...mapFields("company", {
        members: "members",
        recent_activities: "recent_activities",
        usage: "max_usage",
    }),
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      company: "get",
    }),
    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    },
  },
  methods: {
      async getRecentActivities(){
        try {
            // Payload
            let payload = {
                page : this.pagination.page
            };
            var result = await this.$store.dispatch("company/getRecentActivities", payload);
            this.total = result.activities.total;
        } catch (error) {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error"
            });
        } finally {
            this.loading = false;
        }
    },
  }
};
</script>
